<template>
        <section class="cta">
            <v-container>
                <v-row>
                    <v-col md="10" offset-md="3" cols="14" offset="1">
                        <v-row>
                            <v-col sm="8" cols="16" class="cta__center">
                                <h2 class="section-subsubtitle">STAHUJ APLIKACI <span class="cta__image"><img class="cta__coolticket" src="/img/cta/beer-sport-logo.svg"></span></h2>
                                <span class="cta__italic">Aplikace je nutná k zapojení do soutěže.</span>
                            </v-col>
                            <v-col sm="8" cols="16" class="cta__app">
                                <a href="https://play.google.com/store/apps/details?id=cz.akcenaprani.eticket&hl=cs">
                                    <img class="cta__download cta__download--google" src="/img/google-play-logo.svg" width="136px">
                                </a>
                                <a href="https://apps.apple.com/cz/app/cool-ticket/id557970093?l=cs">
                                    <img class="cta__download cta__download--apple" src="/img/appstore-logo.svg" width="136px">
                                </a>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </section>
</template>

<script>
    export default {
        name: 'CtaBlock',
    }
</script>

